interface SectionHeaderProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  className?: string;
}

export default function SectionHeader({ eyebrow, title, desc, align = "left", className = "" }: SectionHeaderProps) {
  const alignCls = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col ${alignCls} max-w-2xl ${className}`}>
      <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 text-accent-700 px-3 py-1 text-xs font-semibold tracking-wide">
        <i className="ri-fire-line text-sm" />
        {eyebrow}
      </span>
      <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950 leading-tight">
        {title}
      </h2>
      {desc ? <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p> : null}
    </div>
  );
}